import { createSlice } from "@reduxjs/toolkit";

const initialState = {
  loading: false,
  message: null,
  error: null,
  data: [],
};

const getHealthProductSlice = createSlice({
  name: "getHealthProduct",
  initialState,
  reducers: {
    getHealthProductStart(state, payload) {
      state.loading = true;
      state.error = null;
      state.message = null;
    },

    getHealthProductSuccess(state, action) {
      state.loading = false;
      const flattenedArray = []?.concat(...action?.payload);
      state.data = flattenedArray;
      state.message = action.payload.message;
    },
    getHealthProductFailure(state, action) {
      state.loading = false;
      state.error = action.payload;
      state.message = null;
    },
    clearError: (state) => {
      state.error = null;
    },
    clearMessage: (state) => {
      state.message = null;
    },
  },
});

export const {
  getHealthProductStart,
  getHealthProductSuccess,
  getHealthProductFailure,
  clearError,
  clearMessage,
} = getHealthProductSlice.actions;

export default getHealthProductSlice.reducer;
